import React from "react";

interface ParentBookingsProps {}

export const ParentBookings: React.FC<ParentBookingsProps> = () => {
	return (
		<div className="p-4">
			<h1 className="text-2xl font-bold">Parent Bookings</h1>
			<p>Placeholder for parent bookings page</p>
		</div>
	);
};

export default ParentBookings;
